import { ActivityIndicator } from '@boschebike/ebds-react';

export const Loader = () => (
  <div className="loading-indicator">
    <ActivityIndicator busy="true" />
  </div>
);
